import { ChatModel } from '../enums';

/**
 * Verified 2026-10-17 against OpenAI's per-model input modalities
 * (https://developers.openai.com/api/docs/models) and OpenRouter's
 * architecture.input_modalities (https://openrouter.ai/api/v1/models).
 * False also covers retired/unverified routes absent from that catalog.
 * Every new ChatModel requires an explicit decision; unknown IDs fail closed.
 */
export const MODEL_IMAGE_INPUT_SUPPORT: Readonly<Record<ChatModel, boolean>> = {
  [ChatModel.Gpt61Sol]: true,
  [ChatModel.Gpt6Luna]: true,
  [ChatModel.Gpt56Sol]: true,
  [ChatModel.Gpt56Terra]: true,
  [ChatModel.Gpt56Luna]: true,
  [ChatModel.Gpt55]: true,
  [ChatModel.Gpt54]: true,
  [ChatModel.Gpt54Mini]: true,
  [ChatModel.Gpt54Nano]: true,
  [ChatModel.Gpt41]: true,
  [ChatModel.Gpt41Mini]: true,
  [ChatModel.Gpt41Nano]: true,
  [ChatModel.Gpt5]: true,
  [ChatModel.Gpt5Mini]: true,
  [ChatModel.Gpt5Nano]: true,
  [ChatModel.GptO3Mini]: false,
  [ChatModel.Grok46]: true,
  [ChatModel.Grok45]: true,
  [ChatModel.Grok4Fast]: false,
  [ChatModel.Grok41Fast]: false,
  [ChatModel.Grok4]: false,
  [ChatModel.Grok420]: true,
  [ChatModel.Grok43]: true,
  [ChatModel.Gemini2Flash]: false,
  [ChatModel.Gemini2FlashLite]: false,
  [ChatModel.Gemini25Flash]: true,
  [ChatModel.Gemini25FlashLite]: true,
  [ChatModel.Gemini25Pro]: true,
  [ChatModel.Gemini3FlashPreview]: true,
  [ChatModel.Gemini31FlashLite]: true,
  [ChatModel.Gemini31FlashLitePreview]: true,
  [ChatModel.Gemini37Flash]: true,
  [ChatModel.Gemini36Flash]: true,
  [ChatModel.Gemini35Flash]: true,
  [ChatModel.Gemini35FlashLite]: true,
  [ChatModel.Gemini31ProPreview]: true,
  [ChatModel.Claude35Sonnet]: false,
  [ChatModel.ClaudeSonnet55]: true,
  [ChatModel.ClaudeSonnet5]: true,
  [ChatModel.ClaudeSonnet46]: true,
  [ChatModel.ClaudeOpus47]: true,
  [ChatModel.ClaudeOpus48]: true,
  [ChatModel.ClaudeOpus48Fast]: false,
  [ChatModel.ClaudeOpus5]: true,
  [ChatModel.ClaudeHaiku55]: true,
  [ChatModel.ClaudeHaiku45]: true,
  [ChatModel.Glm52]: false,
  [ChatModel.DeepSeekV4Pro]: false,
  [ChatModel.DeepSeekV4Flash]: false,
  [ChatModel.DeepSeekV41Flash]: true,
  [ChatModel.MiMoV25]: true,
  [ChatModel.MiMoV25Pro]: false,
  [ChatModel.MiniMaxM3]: true,
  [ChatModel.Step37Flash]: true,
  [ChatModel.HunyuanHy3]: false,
  [ChatModel.Gemini38Flash]: true,
  [ChatModel.MuseSpark13]: true,
};

export function modelSupportsImageInput(model: string | undefined): boolean {
  return (
    model !== undefined &&
    Object.hasOwn(MODEL_IMAGE_INPUT_SUPPORT, model) &&
    MODEL_IMAGE_INPUT_SUPPORT[model as ChatModel] === true
  );
}
